import { useCallback, useEffect, useMemo, useState } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import PopUp from 'src/components/design-system/PopUp';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { useContextSelector } from 'use-context-selector';
const InvoiceMpaDetailHeaderCell = () => {
  const [value, setValue] = useState(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  const isInvoiceBudgetPeriodDirty = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceBudgetPeriodDirty
  );
  const setExpandedBudgetPeriodIds = useContextSelector(
    InvoiceContext,
    (value) => value.setExpandedBudgetPeriodIds
  );
  const invoiceBudgetPeriodDataWithErrors = useContextSelector(
    InvoiceContext,
    (value) => value.invoiceBudgetPeriodDataWithErrors
  );
  const invoiceBudgetPeriods = useContextSelector(
    InvoiceContext,
    (value) => value.invoiceBudgetPeriods
  );
  const expandedBudgetPeriodIds = useContextSelector(
    InvoiceContext,
    (value) => value.expandedBudgetPeriodIds
  );
  const isAllItemsExpanded = useMemo(
    () => invoiceBudgetPeriodDataWithErrors?.some((lineItem) => lineItem?.expanded),
    [invoiceBudgetPeriodDataWithErrors]
  );

  useEffect(() => {
    setValue(isAllItemsExpanded);
  }, [isAllItemsExpanded]);

  const handleHeaderCellExpand = useCallback(() => {
    if (!isInvoiceBudgetPeriodDirty) {
      const newValue = !value;
      setValue(newValue);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      const newTimeoutId = setTimeout(() => {
        const budgetPeriodIds = invoiceBudgetPeriods.map((p) => p.rowId);
        setExpandedBudgetPeriodIds(expandedBudgetPeriodIds?.length > 0 ? [] : budgetPeriodIds);
      }, 500);

      setTimeoutId(newTimeoutId);
    }
  }, [
    isInvoiceBudgetPeriodDirty,
    value,
    timeoutId,
    invoiceBudgetPeriods,
    setExpandedBudgetPeriodIds,
    expandedBudgetPeriodIds?.length,
  ]);

  return (
    <th
      className="k-header k-hierarchy-cell"
      style={{ borderBottomWidth: '0px', paddingBottom: '1.5px' }}
    >
      <PopUp
        content={<PopUpContentWrapper type="Error" contents={['Save required']} />}
        show={isInvoiceBudgetPeriodDirty}
      >
        <ExpandCollapseCell
          expand={value}
          onExpand={handleHeaderCellExpand}
          title={isInvoiceBudgetPeriodDirty ? '' : 'Expand/Collapse All'}
          plusIconColor={isInvoiceBudgetPeriodDirty ? '#aaa' : '#fff'}
          minusIconColor={isInvoiceBudgetPeriodDirty ? '#aaa' : '#fff'}
        />
      </PopUp>
    </th>
  );
};
export default InvoiceMpaDetailHeaderCell;
